import { ApiIntegrationServiceOffice } from '../api/api-types/integration-office.api';
import { IntegrationServiceOffice } from '../api/app-types/integration-office.app';
import { addressMock } from './address.mock';
import { integrationServiceMocks } from './integration-service.mock';

export const apiIntegrationOfficeMocks: ApiIntegrationServiceOffice[] = [
	{
		id: 1,
		initial: 'IFD1',
		remark: 'Integrationsfachdienst 1',
		shortName: 'IFD 1',
		address: addressMock,
		contactPoints: [],
		services: [],
	},
	{
		id: 2,
		initial: 'IFD2',
		remark: 'Integrationsfachdienst 2',
		shortName: 'IFD 2',
		address: addressMock,
		contactPoints: [],
		services: [],
	},
	{
		id: 3,
		initial: 'IFD3',
		remark: 'Integrationsfachdienst 3',
		shortName: 'IFD 3',
		address: addressMock,
		contactPoints: [],
		services: [],
	},
];

export const integrationOfficeMocks: IntegrationServiceOffice[] = [
	{
		id: 1,
		initial: 'IFD1',
		remark: 'Integrationsfachdienst 1',
		shortName: 'IFD 1',
		fullTimeJobs: 5,
		address: addressMock,
		contactPoints: [
			{
				id: 1,
				categoryContactPointId: 1,
				contactValue: 'a@example.com',
				preferredWayOfContact: false,
				personTypeId: 1,
				personId: 1,
			},
			{
				id: 2,
				categoryContactPointId: 1,
				contactValue: 'b@example.com',
				preferredWayOfContact: true,
				personTypeId: 1,
				personId: 2,
			},
			{
				id: 3,
				categoryContactPointId: 1,
				contactValue: 'c@example.com',
				preferredWayOfContact: false,
				personTypeId: 1,
				personId: 3,
			},
		],
		services: [integrationServiceMocks[0]],
	},
	{
		id: 2,
		initial: 'IFD2',
		remark: 'Integrationsfachdienst 2',
		shortName: 'IFD 2',
		address: addressMock,
		contactPoints: [],
		services: [],
	},
	{
		id: 3,
		initial: 'IFD3',
		remark: 'Integrationsfachdienst 3',
		shortName: 'IFD 3',
		address: addressMock,
		contactPoints: [],
		services: [],
	},
];
